import AboutGlobal from './AboutGlobal.vue'

export default AboutGlobal
